<template>
  <GmapMap ref="map" :center="center" map-type-id="roadmap" :zoom="12" :options="options">
    <StationMarker
      v-for="station in locatableStations"
      :key="`station-marker.${station.uuid}`"
      :latitude="station.location.coordinates[1]"
      :longitude="station.location.coordinates[0]"
      @click.native="stationMarkerClicked(station)"
    />
  </GmapMap>
</template>

<script>
  import StationMarker from '@/components/StationMarker.vue';

  export default {
    name: 'station-map',
    components: { // GmapMap is not added here because it was added globally to vue in main.js
      StationMarker,
    },
    props: {
      stations: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        center: {
          lat: -34.6158238,
          lng: -58.4332985,
        },
        options: {
          zoomControl: false,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: false,
          disableDefaultUi: false,
        },
      };
    },
    methods: {
      centerMapOnCurrentLocation() {
        if ('geolocation' in navigator) {
          navigator.geolocation.getCurrentPosition((position) => {
            const { latitude, longitude } = position.coords;
            this.center.lat = latitude;
            this.center.lng = longitude;
          });
        }
      },
      async panTo(lat, lng) {
        const map = await this.$refs.map.$mapPromise;
        map.panTo({ lat, lng });
      },
      async stationMarkerClicked(station) {
        const [longitude, latitude] = station.location.coordinates;
        await this.panTo(latitude, longitude);
        this.$emit('station-clicked', station.uuid);
      },
    },
    computed: {
      locatableStations() {
        return this.stations.filter((station) => !!station.location.coordinates);
      },
    },
    mounted() {
      this.centerMapOnCurrentLocation();
    },
  };
</script>

<style lang="scss">
  /* Remove Logo and Licenses from bottom of map */
  a[href^="http://maps.google.com/maps"] {
    display: one !important;
  }

  a[href^="https://maps.google.com/maps"] {
    display: none !important;
  }

  .gmnoprint a, .gmnoprint span, .gm-style-cc {
    display: none;
  }

  .gmnoprint div {
    background: none !important;
  }
</style>
